module.exports = __webpack_public_path__ + "static/media/bpbg-2022-3.c30aff54.gif";